/**
 * Utilitário para gerenciar toasts
 * Sistema simples de notificações
 */

let toastIdCounter = 0;
let toastListeners = [];

/**
 * Adiciona um listener para mudanças nos toasts
 */
export const addToastListener = (listener) => {
  toastListeners.push(listener);
  return () => {
    toastListeners = toastListeners.filter(l => l !== listener);
  };
};

/**
 * Notifica todos os listeners
 */
const notifyListeners = (toasts) => {
  toastListeners.forEach(listener => listener(toasts));
};

/**
 * Armazena os toasts ativos
 */
let activeToasts = [];

/**
 * Adiciona um novo toast
 */
export const showToast = (message, type = 'info', duration = 3000) => {
  const id = ++toastIdCounter;
  let safeMessage = '';
  if (message == null) {
    safeMessage = '';
  } else if (typeof message === 'string' || typeof message === 'number' || typeof message === 'boolean') {
    safeMessage = String(message);
  } else if (typeof message === 'object' && message.userMessage != null) {
    const u = String(message.userMessage);
    const s = message.supportLine != null ? String(message.supportLine) : '';
    safeMessage = s ? `${u} ${s}` : u;
  } else {
    safeMessage = 'Não foi possível exibir a mensagem.';
  }

  const toast = {
    id,
    message: safeMessage,
    type,
    duration,
    visible: true
  };

  activeToasts = [...activeToasts, toast];
  notifyListeners(activeToasts);

  return id;
};

/**
 * Remove um toast
 */
export const hideToast = (id) => {
  activeToasts = activeToasts.filter(t => t.id !== id);
  notifyListeners(activeToasts);
};

/**
 * Limpa todos os toasts
 */
export const clearToasts = () => {
  activeToasts = [];
  notifyListeners(activeToasts);
};

/**
 * Helpers para tipos específicos
 */
export const toast = {
  success: (message, duration) => showToast(message, 'success', duration),
  error: (message, duration) => showToast(message, 'error', duration),
  info: (message, duration) => showToast(message, 'info', duration),
  warning: (message, duration) => showToast(message, 'warning', duration)
};
